import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormTemplate,
  FormSelectAlt,
  PerfectFileUpload,
  FileUpload,
  FileUploadAlt,
  FormInputAlt,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { CreateCostClass } from "../../../../../utils/redux/Finance/CostCenterSlice/CostCenterSlice";
import { Form } from "react-router-dom";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import { CreateKeywords, GetGlobalData, UpdateKeywords } from "../../../../../utils/redux/Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import { useGetAllAccountsQuery } from "../../../../api";

function SetupKeyword() {
  const { data: banks } = useGetAllAccountsQuery({
    Search: "bank",
    // ApprovalStatus: 0,
    PageSize: 10000,
    PageNumber: 1,
  });
  const { editMode, SelectedKeyword, GlobalData } = useSelector(state=> state.companyFund);
  console.log({ GlobalData });
  const navigate = useNavigate();
  const formMethods = useForm({
    mode: "all",
  });
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;

  const feildArray = useFieldArray({
    control: formMethods.control,
    name: "classSetups",
  });
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(GetGlobalData());
  }, []);

  const [selectedBank, setSelectedBank] = useState(null);
  
  
  function setupKeyword(data){
    data.position = parseInt(data.position);
    data.accountName = selectedBank?.accountName;
    data.accountNumber = selectedBank?.accountNumber;


    if(editMode){
      data.id = SelectedKeyword.id
    }
    dispatch(editMode? UpdateKeywords(data) : CreateKeywords(data))
    .then((response)=>{
      console.log({response})
      if(response.meta.requestStatus === 'fulfilled'){
        reset()
        navigate(-1);
      }
    })
  }

  console.log({selectedBank})
  return (
    <RouteLayout title={"Finance"}>
      <PageLayout title={"Setup Keyword"} hasBack={true}>
        <FormProvider {...formMethods}>
          <FormTemplate
            className={DashboardStyle.view_app_components}
            handleSubmit={handleSubmit(setupKeyword)}
          >
            <section className={DashboardStyle.form_section}>
              <h4 className={`text-[#29382A] mt-5 text-[14px] font-[500]`}>Enter the required details</h4>
              <div className={DashboardStyle.inputs_group}>
                <div>
                  <FormInputAlt 
                    title={"Name"}
                    camelCase={"name"}
                    placeholder={"Enter the Keyword"}
                    isOptional={true}
                    array={[]}
                    defaultValue={editMode? SelectedKeyword?.name : ""}
                    moreRegister={{
                      onChange: (e) => { 
                        return null;
                      },
                    }}
                  />
                  <FormSelectAlt
                    title={"Position"}
                    camelCase={"position"}
                    placeholder={"Select Position"}
                    isOptional={false}
                    array={[{name: "Debit", val: 0}, {name: "Credit", val: 1}].map(item=> {
                      return <option value={item.val}>{item.name}</option>
                    })}
                    defaultValue={editMode? SelectedKeyword?.position : ""}
                    moreRegister={{
                      onChange: (e) => { 
                        return null;
                      },
                    }}
                  />
                </div>
                <div>
                  <FormSelectAlt
                    title={"Bank"}
                    camelCase={"AccountName"}
                    placeholder={"Select Bank"}
                    isOptional={false}
                    array={banks?.result?.map((item, i)=> <option key={i} value={item.accountName}>{item.accountName}</option>)}
                    // moreRegister={{
                    //   onChange: (e) => { // what to do when selection changes
                    //     let { value } = e.target;
                    //     // console.log({value})
                    //     let item = GlobalData.Banks?.find(b => b.id === parseInt(value));
                    //     setSelectedBank(item);
                    //     return null;
                    //   },
                    // }}
                  />
                  {selectedBank?.accountNumber &&
                  <FormInputAlt 
                    title={"Account Number"}
                    camelCase={"accountNumber"}
                    placeholder={""}
                    isOptional={true}
                    array={[]}
                    value={selectedBank?.accountNumber}
                    moreRegister={{
                      onChange: (e) => { 
                        return null;
                      },
                    }}
                  />}
                </div>
              </div>
            </section>

            <div className={DashboardStyle.button_cage}>
              <SupportButtons
                onClick={() => { reset(); navigate(-1); }}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Cancel
              </SupportButtons>
              <ActionButtons
                // isLoading={isLoading}
                // disabled={!isValid}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Submit
              </ActionButtons>
            </div>
          </FormTemplate>
        </FormProvider>
      </PageLayout>
    </RouteLayout>
  );
}

export default SetupKeyword;


